  <!-- 车辆档案 -->
  <template>
  <div>
    <!-- 按钮列表 -->
    <butotn-plug :btndata="BTN_CONFIG" @btnEvent="callBack" @clearBtns="clearBtns" @moreParam="moreParam" @queryBtn_ok="queryBtn_ok" ref="btnList" />

    <!-- 查询列表 -->
    <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="isHaseMore" />

    <!-- 表格 -->
    <table-plug :tableConfig="tableConfig" :defaulthead="myTableHeard" :totals="totalArr" ref="mytable" @selectChange="handleSelectionChange" @rowCallback="rowCallback" @jumpPage="goYdDetails" />

    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" />

    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    />

    <!-- 车辆档案新增弹窗 -->
    <my-dialog :diaWidth="diaWidth" :dialogTitle="dialogTitle" :isShowDialog="isShowDialog" @handleCloseDia="handleCloseDia" @diaCancelBtn="diaCancelBtn" @diaConfirmBtn="diaConfirmBtn">
      <el-collapse v-model="activeNames" @change="handleChange">
        <el-collapse-item title="车辆信息" name="1">
          <dia-form :diaFormConfig="diaFormConfig" :baseModel="baseModel" ref="diaform" :rules="formRules" :Reset="isShowDialog" @changeCallback="rowCallback">
            <template slot="img1">
              <uploadimgs @input="changeFileList_1" :fileNameLists="fileNameLists_1" :limit="9" />
            </template>
            <template slot="slotLabel">
              <div class="imglists">
                <div class="setper" v-if="listShipper.length">
                  <div class="s_tem" v-for="(item, index) in listShipper" :key="index">
                    <span>{{ item.label }}</span>
                    <i class="el-icon-error" @click="clickDel(index)"></i>
                  </div>
                </div>
                <el-button style="margin-top: 10px" size="small" class="glo_bgcMainColor" @click="addlistShipper">添加</el-button>
              </div>
            </template>
          </dia-form>
        </el-collapse-item>
        <!-- <el-collapse-item title="保险管理" name="2">
          <div class="glo_Table goodsTable">
            <el-table :data="insuranccecReq" border style="width: 100%">
              <el-table-column show-overflow-tooltip prop="itemCategoryName" label="保险险种">
                <template slot-scope="scope">
                  <el-select v-model="insuranccecReq[scope.$index].insuranceCoverage" filterable clearable allow-create default-first-option placeholder="请选择">
                    <el-option v-for="item2 in insuranceCoverageArrs" :key="item2.key" :label="item2.key" :value="item2.key"></el-option>
                  </el-select>
                </template>
              </el-table-column>

              <el-table-column show-overflow-tooltip prop="goodsName" label="保险单号">
                <template slot-scope="scope">
                  <el-input type="text" v-model="insuranccecReq[scope.$index].insuranceNumber" placeholder="请输入" filterable></el-input>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="goodsName" label="保险到期时间">
                <template slot-scope="scope">
                  <el-date-picker v-model="insuranccecReq[scope.$index].insuranceDateEnd" value-format="yyyy-MM-dd" type="date" placeholder="请选择"></el-date-picker>
                </template>
              </el-table-column>

              <el-table-column label="操作">
                <template slot-scope="scope">
                  <div class="iconList">
                    <i v-if="insuranccecReq.length == scope.$index + 1" class="el-icon-circle-plus iconSize" @click="AddGoods(scope.$index)"></i>
                    <el-popconfirm v-if="insuranccecReq.length > 1" title="确定删除该行数据吗" @confirm="delGoods(scope.$index)">
                      <i slot="reference" class="el-icon-remove iconSize"></i>
                    </el-popconfirm>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-collapse-item>-->
        <el-collapse-item title="车辆道路运输许可证" name="3">
          <div>
            <dia-form :diaFormConfig="diaFormConfig3" :baseModel="daoLuLicenceReq" ref="diaform3" :Reset="isShowDialog" @changeCallback="rowCallback">
              <template slot="img1">
                <uploadimgs @input="changeFileList_3" :fileNameLists="fileNameLists_3" :limit="9" />
              </template>
            </dia-form>
          </div>
        </el-collapse-item>
        <el-collapse-item title="道路运输资质、经营许可证" name="4">
          <div>
            <dia-form :diaFormConfig="diaFormConfig4" :baseModel="jingYunLicenceReq" ref="diaform4" :Reset="isShowDialog" @changeCallback="rowCallback">
              <template slot="img1">
                <uploadimgs @input="changeFileList_4" :fileNameLists="fileNameLists_4" :limit="9" />
              </template>
            </dia-form>
          </div>
          <div>
            <dia-form :diaFormConfig="diaFormConfig5" :baseModel="yingYeLicenceReq" ref="diaform4" :Reset="isShowDialog" @changeCallback="rowCallback">
              <template slot="img1">
                <uploadimgs @input="changeFileList_5" :fileNameLists="fileNameLists_5" :limit="9" />
              </template>
            </dia-form>
          </div>
        </el-collapse-item>
      </el-collapse>
    </my-dialog>
    <myDialog :diaWidth="diaWidth1" :dialogTitle="dialogTitle1" :isShowDialog="isShowDialog1" @handleCloseDia="handleCloseDia1" @diaCancelBtn="handleCloseDia1" @diaConfirmBtn="diaConfirmBtn1">
      <div class="formbox" v-if="isShowDialog1">
        <el-form class="glo_formBox" label-width="80px">
          <el-form-item label="新标签:" style="width: 100%">
            <el-input v-model="dialogForm1.label" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 查询列表 -->
      <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="true" />
    </exportCompoent>
  </div>
</template>
  <script >
import { mixin_1 } from "@/assets/js/Mixins/mixin";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import ButotnPlug from "@/components/Modules/ButtonPlug.vue";
import InputPlug from "@/components/Modules/InputPlug.vue";
import multitime from "@/components/multiTime.vue";
import paging from "@/components/pagings.vue"; //分页组件
import TablePlug from "@/components/Modules/TablePlug.vue";
import MyDialog from "@/components/Dialog.vue";
import DiaForm from "@/pages/VMS/VMSConpon/DiaForm.vue";
import uploadimgs from "@/components/upLoadImgs.vue";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js
export default {
  mixins: [mixin_1, exportjs],
  components: {
    ButotnPlug,
    InputPlug,
    multitime,
    TablePlug,
    paging,
    sorttable,
    MyDialog,
    DiaForm,
    uploadimgs,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "车辆档案", //导出时默认文件名
        apiName: "/admin/v3/tms/car/getCarList", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      listShipper: [],
      diaWidth1: "350px",
      dialogTitle1: "添加标签",
      isShowDialog1: false,
      dialogForm1: {
        label: "",
      },

      insuranceCoverageArrs: [], //险种

      activeNames: ["1", "2", "3", "4"],
      // 按钮配置
      BTN_CONFIG: [
        {
          name: "新增",
          method: "addClick",
          permissVal: "admin:car:addCar",
        },
        {
          name: "修改",
          method: "modifyClick",
          permissVal: "admin:car:udpateCar",
        },
        {
          name: "删除",
          method: "delete",
          permissVal: "admin:car:delCar",
        },
        {
          name: "启用",
          method: "startUsing",
          permissVal: "admin:car:startCar",
        },
        {
          name: "禁用",
          method: "Disable",
          permissVal: "admin:car:stopCar",
        },
        // {
        //   name: "画像标签",
        //   method: "modifyClick",
        //   permissVal: "admin:car:udpateCar",
        // },
        {
          name: "表格设置",
          method: "SetTable",
          permissVal: "aaaaa",
        },
        {
          name: "导出",
          method: "ExportData",
          permissVal: "aaaaa",
        },
      ],
      // 更多搜索
      isHaseMore: false,
      //  查询框
      baseConfig: [
        {
          type: "select",
          label: "车辆类型",
          field: "carCategoryConfDictId",
          placeholder: "请选择",
          setLabel: "val",
          setValue: "confDictId",
          selectOptions: [],
        },
        {
          type: "input",
          label: "车牌号码",
          field: "carNumber",
          placeholder: "请输入",
        },
        {
          type: "input",
          label: "司机姓名",
          field: "driverName",
          placeholder: "请输入",
        },
        {
          type: "input",
          label: "车主姓名",
          field: "ownerName",
          placeholder: "请输入",
        },
        {
          type: "select",
          label: "车型",
          field: "carTypeConfDictId",
          placeholder: "请选择",
          setLabel: "val",
          setValue: "confDictId",
          selectOptions: [],
        },
      ],

      queryData: {
        carCategoryConfDictId: null,
        carNumber: null,
        carTypeConfDictId: null,
        driverName: null,
        ownerName: null,
      },

      // 表格配置
      tableConfig: {
        tableHeigth: "75vh",
        tableData: [],
      },
      className: "", //  导出需要
      pageGroupName: "CarArchive", //  页面标识
      myTableHeard: [],
      tabelHeadeTitle: [
        {
          name: "操作",
          field: "edit",
          width: 220,
          Buttons: [
            {
              method: "modifyClick",
              methodName: "修改",
              permissVal: "admin:car:udpateCar",
            },
            {
              method: "delete",
              methodName: "删除",
              permissVal: "admin:car:delCar",
            },
            {
              method: "startUsing",
              methodName: "启用",
              permissVal: "admin:car:startCar",
            },
            {
              method: "Disable",
              methodName: "禁用",
              permissVal: "admin:car:stopCar",
            },
          ],
        },
        {
          name: "画像标签",
          field: "portraitLabel",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "车牌号码",
          field: "carNumber",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "车辆分类",
          field: "carCategoryName",
          sort: 4,
          isShow: true,
        },
        {
          name: "车型",
          field: "carTypeName",
          sort: 5,
          isShow: true,
        },
        {
          name: "车辆使用部门",
          field: "useDeptName",
          sort: 5,
          isShow: true,
        },
        {
          name: "任务状态",
          field: "taskStatusShow",
          sort: 6,
          isShow: true,
        },
        {
          name: "启用状态",
          field: "carStatusShow",
          sort: 1,
          isShow: true,
        },
        {
          name: "最新发车批次号",
          field: "aaa",
          width: "200",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "行驶证号",
          field: "drivingLicenseNo",
          sort: 18,
          isShow: true,
          isSort: true,
        },
        {
          name: "年检到期时间",
          field: "annualCheckEndTime",
          sort: 18,
          isShow: true,
          isSort: true,
        },
        {
          name: "保养到期时间",
          field: "maintenanceDueTime",
          sort: 18,
          isShow: true,
          isSort: true,
        },
        {
          name: "强制报废时间",
          field: "forcedRetirementDate",
          sort: 18,
          isShow: true,
          isSort: true,
        },
        {
          name: "车架号码",
          field: "frameNumber",
          sort: 19,
          isShow: true,
          isSort: true,
        },
        {
          name: "挂车号码",
          field: "trailerNumber",
          width: "120",
          sort: 1,
          isShow: true,
          isSort: true,
        },
        {
          name: "发动机号",
          field: "engineNumber",
          sort: 1,
          isShow: true,
          isSort: true,
        },
        {
          name: "营运证号",
          field: "operationCertificateNo",
          sort: 2,
          isShow: true,
          isSort: true,
        },
        {
          name: "可载重量",
          field: "loadableCapacity",
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },

        {
          name: "可载体积",
          field: "loadableVolume",
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "车辆皮重",
          field: "packageWeight",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "保险单号",
          field: "policyNo",
          sort: 1,
          isShow: true,
          isSort: true,
        },
        {
          name: "附加费证号",
          field: "surchargeCertificateNo",
          sort: 1,
          isShow: true,
          isSort: true,
        },
        {
          name: "司机姓名",
          field: "driverName",
          width: "120",
          sort: 180,
          isShow: true,
          isTotal: false,
          isSort: true,
        },

        {
          name: "司机电话",
          field: "driverPhone",
          sort: 6,
          isShow: true,
          isSort: true,
        },
        {
          name: "家庭电话",
          field: "driverTel",
          sort: 1,
          isShow: true,
          isSort: true,
        },

        {
          name: "身份证号",
          field: "driverIdCard",
          sort: 1,
          isShow: true,
          isSort: true,
        },
        {
          name: "司机住址",
          field: "driverAddress",
          sort: 1,
          isShow: true,
        },
        {
          name: "驾驶证号",
          field: "driverLicenseNumber",
          sort: 1,
          isShow: true,
          isSort: true,
        },
        {
          name: "车主姓名",
          field: "ownerName",
          sort: 1,
          isShow: true,
        },
        {
          name: "车主电话",
          field: "ownerPhone",
          sort: 1,
          isShow: true,
          isSort: true,
        },
        {
          name: "车主地址",
          field: "ownerAddress",
          sort: 1,
          isShow: true,
          isSort: true,
        },
        {
          name: "车属单位",
          field: "company",
          sort: 1,
          isShow: true,
        },
        {
          name: "单位电话",
          field: "companyPhone",
          sort: 1,
          isShow: true,
          isSort: true,
        },
        {
          name: "单位地址",
          field: "companyAddress",
          sort: 1,
          isShow: true,
        },
        {
          name: "备注",
          field: "remarks",
          sort: 1,
          isShow: true,
        },
        {
          name: "新增人",
          field: "createUsersName",
          sort: 1,
          isShow: true,
        },
        {
          name: "新增时间",
          field: "createTime",
          sort: 1,
          isShow: true,
          isSort: true,
        },
        {
          name: "修改人",
          field: "updateUserName",
          sort: 1,
          isShow: true,
        },
        {
          name: "修改时间",
          field: "updateTime",
          sort: 1,
          isShow: true,
        },
      ],
      sortName: "车辆档案", //  排序名
      //   车辆弹窗
      diaWidth: "60%",
      dialogTitle: "车辆档案",
      isShowDialog: false,
      diaFormConfig: [
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "车辆分类",
              itemType: "select",
              field: "carCategoryConfDictId",
              placeholder: "请选择",
              setLabel: "val",
              setValue: "confDictId",
              options: [],
            },
            {
              span: 8,
              title: "车牌号码",
              itemType: "input",
              field: "carNumber",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "车型",
              itemType: "select",
              field: "carTypeConfDictId",
              setLabel: "val",
              setValue: "confDictId",
              placeholder: "请选择",
              options: [],
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "车辆使用部门",
              itemType: "selectloadmore",
              field: "useDeptId",
              labelwidth: 120,
              placeholder: "输入部门进行匹配",
              loadmoreMethod: "loadCardept",
              remotemethod: "remoteCardept",
              loading: false,
              setLabel: "departmentName",
              setValue: "deptId",
              options: [],
            },
            {
              span: 8,
              title: "归属承运商",
              itemType: "selectloadmore",
              field: "carrierId",
              placeholder: "输入承运商进行匹配",
              loadmoreMethod: "loadCarrier",
              remotemethod: "remoteCarrier",
              loading: false,
              setLabel: "name",
              setValue: "documentId",
              options: [],
            },
            {
              span: 8,
              title: "活动区域",
              itemType: "input",
              field: "actionZone",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "机油保养到期",
              itemType: "date",
              field: "maintenanceDueTime",
              placeholder: "请选择日期",
            },
            {
              span: 8,
              title: "刹车保养到期",
              itemType: "date",
              field: "brakeMaintenanceDueTime",
              placeholder: "请选择日期",
            },
            {
              span: 8,
              title: "打黄油保养到期",
              itemType: "date",
              field: "oilMaintenanceDueTime",
              placeholder: "请选择日期",
            },
            {
              span: 8,
              title: "年检到期时间",
              itemType: "date",
              field: "annualCheckEndTime",
              placeholder: "请选择日期",
            },
            {
              span: 8,
              title: "强制报废时间",
              itemType: "date",
              field: "forcedRetirementDate",
              placeholder: "请选择日期",
            },
            {
              span: 8,
              title: "定级到期时间",
              itemType: "date",
              field: "ratingDueEndDate",
              placeholder: "请选择日期",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "使用性质",
              itemType: "input",
              field: "useNature",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "品牌型号",
              itemType: "input",
              field: "brandModel",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "档案编号",
              itemType: "input",
              field: "drivingLicenseNo",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "车辆识别代码",
              itemType: "input",
              field: "frameNumber",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "发动机号",
              itemType: "input",
              field: "engineNumber",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "附加费证号",
              itemType: "input",
              field: "surchargeCertificateNo",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "注册日期",
              itemType: "date",
              field: "registrationDate",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "发证日期",
              itemType: "date",
              field: "issueDate",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "发证机关",
              itemType: "input",
              field: "issueAuthority",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "核定载人数",
              itemType: "input",
              field: "approvedPeopleCount",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "核定载质量",
              itemType: "input",
              field: "loadableCapacity",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "可载体积",
              itemType: "input",
              field: "loadableVolume",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "整备质量",
              itemType: "input",
              field: "vehicleTare",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "牵引总质量",
              itemType: "input",
              field: "totalTractionMass",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "尾板质量",
              itemType: "input",
              field: "tailPlateQuality",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "总质量",
              itemType: "input",
              field: "totalQuality",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "外廓尺寸",
              itemType: "input",
              field: "outerSize",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "挂车号码",
              itemType: "input",
              field: "trailerNumber",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "内箱尺寸",
              itemType: "input",
              field: "boxSize",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "车主姓名",
              itemType: "input",
              field: "ownerName",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "车主电话",
              itemType: "input",
              field: "ownerPhone",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "车主地址",
              itemType: "input",
              field: "ownerAddress",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "车属单位",
              itemType: "input",
              field: "company",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "单位电话",
              itemType: "input",
              field: "companyPhone",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "单位地址",
              itemType: "input",
              field: "companyAddress",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "司机姓名",
              itemType: "selectloadmore",
              field: "driverId",
              loadmoreMethod: "loadDrivers",
              remotemethod: "remoteDrivers",
              loading: false,
              setLabel: "driverName",
              setValue: "driverId",
              selectChange: "selectDriver",
              placeholder: "输入司机姓名进行匹配",
              options: [],
            },
            {
              span: 8,
              title: "司机电话",
              itemType: "input",
              field: "phone",
              disabled: true,
              placeholder: "自动填充",
            },
            {
              span: 8,
              title: "身份证号",
              itemType: "input",
              field: "idCard",
              disabled: true,
              placeholder: "自动填充",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "家庭电话",
              itemType: "input",
              field: "tel",
              disabled: true,
              placeholder: "自动填充",
            },
            {
              span: 8,
              title: "司机住址",
              itemType: "input",
              field: "address",
              disabled: true,
              placeholder: "自动填充",
            },
            {
              span: 8,
              title: "驾驶证号",
              itemType: "input",
              field: "driverLicenseNumber",
              disabled: true,
              placeholder: "自动填充",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 24,
              title: "备注",
              itemType: "textarea",
              field: "remarks",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 24,
              title: "图片上传",
              itemType: "upload",
              slot: "img1",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 24,
              title: "画像标签",
              itemType: "selectload",
              slot: "slotLabel",
            },
          ],
        },
      ],
      diaFormConfig3: [
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "业户名称",
              itemType: "input",
              field: "businessName",
              disabled: false,
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "道路运输证号",
              itemType: "input",
              field: "licenceNumber",
              disabled: false,
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "核发机关",
              itemType: "input",
              field: "issuingOrgan",
              disabled: false,
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "发证日期",
              itemType: "date",
              field: "issueDate",
              disabled: true,
              placeholder: "自动填充",
            },
            {
              span: 8,
              title: "生效日期",
              itemType: "date",
              field: "effectiveDate",
              disabled: true,
              placeholder: "自动填充",
            },
            {
              span: 8,
              title: "到期日期",
              itemType: "date",
              field: "expirationDate",
              disabled: true,
              placeholder: "自动填充",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 24,
              title: "图片上传",
              itemType: "upload",
              slot: "img1",
            },
          ],
        },
      ],
      diaFormConfig4: [
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "业户名称",
              itemType: "input",
              field: "businessName",
              disabled: false,
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "运营证号",
              itemType: "input",
              field: "licenceNumber",
              disabled: false,
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "核发机关",
              itemType: "input",
              field: "issuingOrgan",
              disabled: false,
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "发证日期",
              itemType: "date",
              field: "issueDate",
              disabled: true,
              placeholder: "自动填充",
            },
            {
              span: 8,
              title: "生效日期",
              itemType: "date",
              field: "effectiveDate",
              disabled: true,
              placeholder: "自动填充",
            },
            {
              span: 8,
              title: "到期日期",
              itemType: "date",
              field: "expirationDate",
              disabled: true,
              placeholder: "自动填充",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 24,
              title: "经验范围",
              itemType: "textarea",
              field: "licenceScope",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 24,
              title: "许可证图片",
              itemType: "upload",
              slot: "img1",
            },
          ],
        },
      ],
      diaFormConfig5: [
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "营业执照号",
              itemType: "input",
              field: "businessName",
              disabled: false,
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "核发机关",
              itemType: "input",
              field: "issuingOrgan",
              disabled: false,
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "发证日期",
              itemType: "date",
              field: "issueDate",
              disabled: false,
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "生效日期",
              itemType: "date",
              field: "effectiveDate",
              disabled: false,
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "到期日期",
              itemType: "date",
              field: "expirationDate",
              disabled: false,
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 24,
              title: "营业执照图片",
              itemType: "upload",
              slot: "img1",
            },
          ],
        },
      ],
      formRules: {
        carNumber: [
          { required: true, message: "请输入车牌号码", trigger: "blur" },
        ],
        carCategoryConfDictId: [
          { required: true, message: "请选择车辆分类", trigger: "change" },
        ],
        carTypeConfDictId: [
          { required: true, message: "请选择车型", trigger: "change" },
        ],
        useDeptId: [
          { required: true, message: "请选择使用部门", trigger: "change" },
        ],
        // carrierId: [
        //   { required: true, message: "请选择承运商", trigger: "change" },
        // ],
      },
      baseModel: {},

      defaultBaseModel: {
        carCategoryConfDictId: null,
        carNumber: null,
        carTypeConfDictId: null,
        useDeptId: null,
        carrierId: null,
        company: null,
        companyAddress: null,
        companyPhone: null,
        driverId: null,
        drivingLicenseNo: null,
        engineNumber: null,
        frameNumber: null,
        loadableCapacity: null,
        loadableVolume: null,
        operationCertificateNo: null,
        ownerAddress: null,
        ownerName: null,
        ownerPhone: null,
        policyNo: null,
        remarks: null,
        surchargeCertificateNo: null,
        trailerNumber: null,
        // 下面新增的
        actionZone: null,
        annualCheckEndTime: null,
        approvedPeopleCount: null,
        brandModel: null,
        carCategoryConfDictId: null,
        carTypeConfDictId: null,
        forcedRetirementDate: null,
        issueAuthority: null,
        issueDate: null,
        brakeMaintenanceDueTime:null,
        maintenanceDueTime: null,
        outerSize: null,
        registrationDate: null,
        tailPlateQuality: null,
        totalQuality: null,
        totalTractionMass: null,
        useNature: null,
        vehicleTare: null,
        boxSize: null,
        portraitLabel: null,
        ratingDueEndDate: null,
        //  fileIds: [],
        //  daoLuLicenceReq: {}, //车辆道路运输许可证
        //  insuranccecReq: [], //保险管理
        //  jingYunLicenceReq: {}, //车辆道路运输经营许可证
      },
      // 车辆道路运输许可证
      daoLuLicenceReq: {
        businessName: "",
        effectiveDate: "",
        expirationDate: "",
        fileIds: [],
        insuranceDateEnd: "",
        issueDate: "",
        issuingOrgan: "",
        licenceNumber: "",
        licenceScope: "",
        insuranceDateEnd: "",
      },
      // 车辆道路运输经营许可证
      jingYunLicenceReq: {
        businessName: "",
        effectiveDate: "",
        expirationDate: "",
        fileIds: [],
        insuranceDateEnd: "",
        issueDate: "",
        issuingOrgan: "",
        licenceNumber: "",
        licenceScope: "",
        insuranceDateEnd: "",
      },

      yingYeLicenceReq: {
        businessName: "",
        effectiveDate: "",
        expirationDate: "",
        fileIds: [],
        insuranceDateEnd: "",
        issueDate: "",
        issuingOrgan: "",
        licenceNumber: "",
        licenceScope: "",
        insuranceDateEnd: "",
      },
      // // 保险管理
      // insuranccecReq: [
      //   {
      //     insuranceCoverage: "",
      //     insuranceDateEnd: "",
      //     insuranceNumber: "",
      //   },
      // ],

      CarrierPage: {
        pageStart: 1,
        pageTotal: 20,
        pageCount: 0,
      },
      DriverPage: {
        pageStart: 1,
        pageTotal: 20,
        pageCount: 0,
      },
      DeptPage: {
        pageStart: 1,
        pageTotal: 20,
        pageCount: 0,
      },
      fileNameLists_1: [],
      fileNameLists_3: [],
      fileNameLists_4: [],
      fileNameLists_5: [],
      delArrs: [],
      openType: "",
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },

  created() {
    this.GetConfDictValDownList("car_category");
    this.GetConfDictValDownList("car_type");
    // this.GetObjectUserDownList("dept");
    this.GetObjectUserDownList("carrier");
    this.GetCardept();
    this.GetDrivers();
    this.GetData();
    this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName);

    this.getConfDictValDownList();
  },

  methods: {
    handleCloseDia1() {
      this.isShowDialog1 = false;
      this.dialogForm1 = {
        label: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn1() {
      this.listShipper.push({
        label: this.dialogForm1.label,
      });
      this.isShowDialog1 = false;
    },
    clickDel(index) {
      this.listShipper.splice(index, 1);
    },
    async addlistShipper(key) {
      this.isShowDialog1 = true;
    },
    handleChange(val) {
      console.log(val);
    },
    changeFileList_1(array) {
      this.fileNameLists_1 = array;
    },
    changeFileList_3(array) {
      this.fileNameLists_3 = array;
    },
    changeFileList_4(array) {
      this.fileNameLists_4 = array;
    },
    changeFileList_5(array) {
      this.fileNameLists_5 = array;
    },

    getConfDictValDownList() {
      this.$COMAPI.getConfDictValDownList("insurance_type").then((res) => {
        this.insuranceCoverageArrs = res || [];
      }); //保险类型
    },

    // // 新增一行保险信息
    // AddGoods() {
    //   let objs = {
    //     insuranceCoverage: "",
    //     insuranceDateEnd: "",
    //     insuranceNumber: "",
    //   };
    //   if (this.openType == "edit") {
    //     objs.operationType = "ADD";
    //   }
    //   this.insuranccecReq.push(objs);
    // },
    // // 删除一行保险信息
    // delGoods(idx) {
    //   let datas = JSON.parse(JSON.stringify(this.insuranccecReq));
    //   if (this.openType == "edit") {
    //     // 编辑
    //     if (datas[idx].operationType == "UPDATE") {
    //       datas[idx].operationType = "DEL";
    //       this.delArrs.push(datas[idx]);
    //     }
    //   }
    //   datas.splice(idx, 1);
    //   this.insuranccecReq = datas;
    // },

    // 获取车辆档案列表
    GetData() {
      this.queryData.pageStart = this.pageStart;
      this.queryData.pageTotal = this.pageTotal;

      this.$API.CarArchiveList(this.queryData).then((res) => {
        if (res.data.status === "success") {
          this.className = res.data.result.className || "";
          this.tableConfig.tableData = res.data.result.data || [];
          this.pageCount = res.data.result.pageCount || 0;
          this.$nextTick(() => {
            this.fetTableHeight();
          });
        } else {
          this.$message.error(`${res.data.message}---车辆档案列表`);
        }
      });
    },

    // 获取车辆类型 & 车型
    GetConfDictValDownList(param) {
      this.$API.getConfDictValDownList({ dictType: param }).then((res) => {
        if (res.data.status === "success") {
          let result = res.data.result || [];
          // 车辆类型
          if (param === "car_category") {
            this.baseConfig[0].selectOptions = result;
            this.diaFormConfig[0].formItem[0].options = result;
          }
          // 车型
          if (param === "car_type") {
            this.baseConfig[4].selectOptions = result;
            this.diaFormConfig[0].formItem[2].options = result;
          }
        }
      });
    },

    // 获取归属承运商
    GetObjectUserDownList(param, e, checkedData) {
      let query = {
        pageStart: this.CarrierPage.pageStart,
        pageTotal: this.CarrierPage.pageTotal,
        name: e,
        key: param,
        number: checkedData,
      };
      this.$API.getObjectUserDownList(query).then((res) => {
        this.diaFormConfig[1].formItem[1].loading = false;
        if (res.data.status === "success") {
          let result = res.data.result?.data || [];
          let arr = this.diaFormConfig[1].formItem[1].options;
          if (e) {
            this.diaFormConfig[1].formItem[1].options = result;
          } else {
            this.diaFormConfig[1].formItem[1].options = [
              ...arr,
              ...result.filter(
                (item) => !arr.some((x) => x.number === item.number)
              ),
            ];
          }
          if (!e && !checkedData) {
            this.CarrierPage.pageCount = res.data.result?.pageCount || 0;
          }
        }
      });
    },
    //  归属承运商 select 滚动加载更多数据
    loadCarrier() {
      let count = this.CarrierPage.pageCount / this.CarrierPage.pageTotal;
      if (count > this.CarrierPage.pageStart) {
        this.diaFormConfig[4].formItem[2].loading = true;
        this.CarrierPage.pageStart += 1;
        this.GetObjectUserDownList("carrier");
      } else {
        console.log("数据已全部加载");
      }
    },
    // 归属承运商远程搜索
    remoteCarrier(e) {
      // 当输入框有关键字的时候，loading为true显示加载圈圈，请求对应关键字数据
      this.CarrierPage.pageStart = 1;
      if (e !== "") {
        this.diaFormConfig[4].formItem[2].loading = true;
        this.GetObjectUserDownList("carrier", e);
      } else {
        this.GetObjectUserDownList("carrier");
      }
    },
    // 获取车辆使用部门
    GetCardept(e, checkedData) {
      let query = {
        pageStart: this.DeptPage.pageStart,
        pageTotal: this.DeptPage.pageTotal,
        deptName: e,
        deptId: checkedData,
      };
      this.$API
        .wtl_getDeptList(query)
        .then((res) => {
          this.diaFormConfig[1].formItem[0].loading = false;
          if (res.data.status === "success") {
            let result = res.data.result?.data || [];
            let arr = this.diaFormConfig[1].formItem[0].options;
            if (e) {
              this.diaFormConfig[1].formItem[0].options = result;
            } else {
              this.diaFormConfig[1].formItem[0].options = [
                ...arr,
                ...result.filter(
                  (item) => !arr.some((x) => x.deptId === item.deptId)
                ),
              ];
            }
            if (!e && !checkedData) {
              this.DeptPage.pageCount = res.data.result?.pageCount || 0;
            }
          }
        })
        .catch((catchres) => {
          this.diaFormConfig[1].formItem[0].loading = false;
        });
    },

    // 车辆使用部门远程搜索
    remoteCardept(e) {
      // 当输入框有关键字的时候，loading为true显示加载圈圈，请求对应关键字数据
      this.DeptPage.pageStart = 1;
      if (e !== "") {
        this.diaFormConfig[4].formItem[1].loading = true;
        this.GetCardept(e);
      } else {
        this.GetCardept();
      }
    },

    loadCardept() {
      let count = this.DeptPage.pageCount / this.DeptPage.pageTotal;
      if (count > this.DeptPage.pageStart) {
        this.diaFormConfig[4].formItem[1].loading = true;
        this.DeptPage.pageStart += 1;
        this.GetCardept();
      } else {
        console.log("数据已全部加载");
      }
    },
    // 获取司机(参数e是远程搜索传来的，checkedData是修改时传来的回显数据)
    GetDrivers(e, checkedData) {
      let query = {
        pageStart: this.DriverPage.pageStart,
        pageTotal: this.DriverPage.pageTotal,
        driverName: e,
        userId: checkedData,
      };
      this.$API
        .DriverDownList(query)
        .then((res) => {
          this.diaFormConfig[11].formItem[0].loading = false;
          if (res.data.status === "success") {
            let result = res.data.result?.data || [];
            let arr = this.diaFormConfig[11].formItem[0].options;
            if (e) {
              // 有搜索条件时直接赋值请求后的全部数据
              this.diaFormConfig[11].formItem[0].options = result;
            } else {
              // 回显以及翻页返回的数据进行合并
              this.diaFormConfig[11].formItem[0].options = [
                ...arr,
                ...result.filter(
                  (item) => !arr.some((x) => x.driverId === item.driverId)
                ),
              ];
            }
            // 以页码拉取数据的时候赋值 DriverPage.pageCount
            if (!e && !checkedData) {
              this.DriverPage.pageCount = res.data.result?.pageCount || 0;
            }
          }
        })
        .catch((catchres) => {
          // 数据请求失败后关闭加载小圈
          this.diaFormConfig[11].formItem[0].loading = false;
        });
    },
    remoteDrivers(e) {
      // 当输入框有关键字的时候，loading为true显示加载圈圈，请求对应关键字数据
      // 每次远程搜索时重置页码为1
      this.DriverPage.pageStart = 1;
      if (e !== "") {
        this.diaFormConfig[11].formItem[0].loading = true;
        this.GetDrivers(e);
      } else {
        this.GetDrivers();
      }
    },
    // 下拉加载更多数据无需传参数
    loadDrivers() {
      // 当count大于当前页码，下拉+1页码请求数据，
      let count = this.DriverPage.pageCount / this.DriverPage.pageTotal;
      if (count > this.DriverPage.pageStart) {
        this.diaFormConfig[11].formItem[0].loading = true;
        this.DriverPage.pageStart += 1;
        this.GetDrivers();
      } else {
        console.log("数据已全部加载");
      }
    },
    // 选中司机自动填充司机信息
    selectDriver(e) {
      let r = {};
      if (e) {
        let index = this.diaFormConfig[11].formItem[0].options.findIndex(
          (elem) => elem.driverId == e
        );
        r = this.diaFormConfig[11].formItem[0].options[index];
      }
      this.baseModel.phone = r.phone || "";
      this.baseModel.idCard = r.idCard || "";
      this.baseModel.tel = r.tel || "";
      this.baseModel.driverLicenseNumber = r.driverLicenseNumber || "";
      this.baseModel.address = r.address || "";
    },

    // 表格内按钮的回调事件
    rowCallback(data, name) {
      this[name](data);
    },
    // 更多搜索
    moreParam(e) {
      this.isHaseMore = e;
      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },
    // 表格设置
    SetTable() {
      this.$TOOLS.myModel(this);
    },
    // 导出
    ExportData() {
      // this.$COMAPI.exportBtn({
      //   pageGroupName: this.pageGroupName, //页面标识
      //   myTableHeard: this.myTableHeard, //表头数组
      //   className: this.className, //列表标识
      //   tableData: this.tableConfig.tableData, //数据源
      //   sheetName: "表名(暂无效)", //表名
      // });
      this.isShowDialog_dc = true;
    },
    // 新增
    addClick() {
      this.listShipper = [];
      this.isShowDialog = true;
      this.openType = "add";
    },
    // 修改
    modifyClick(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length !== 1) {
        this.$message.error("请选择一条数据进行操作");
        return false;
      } else {
        // this.isShowDialog = true;
        // this.baseModel = this.selectTableData[0];
        this.openType = "edit";
        this.getCarDetail(this.selectTableData[0].carId);
      }
    },
    // 车辆详情
    getCarDetail(carId) {
      this.listShipper = [];
      this.$API.getCarDetail({ carId: carId }).then((res) => {
        this.isShowDialog = true;
        let datas = res.data.result;

        this.daoLuLicenceReq = datas.daoLuLicenceVo || {};
        this.jingYunLicenceReq = datas.jingYunLicenceVo || {};
        this.yingYeLicenceReq = datas.yingYeLicenceVo || {};
        // this.insuranccecReq = datas.insuranccecVo || [];

        // this.insuranccecReq.forEach((item) => {
        //   item.operationType = "UPDATE";
        // });

        let fileIds1 = datas.fileIds || [];
        this.fileNameLists_1 = fileIds1.map((item) => {
          let obj = {
            name: item.fileId,
            url: item.fileUrl,
          };
          return obj;
        });
        let fileIds3 = datas.daoLuLicenceVo
          ? datas.daoLuLicenceVo.fileIds || []
          : [];
        this.fileNameLists_3 = fileIds3.map((item) => {
          let obj = {
            name: item.fileId,
            url: item.fileUrl,
          };
          return obj;
        });
        let fileIds4 = datas.jingYunLicenceVo
          ? datas.jingYunLicenceVo.fileIds || []
          : [];
        this.fileNameLists_4 = fileIds4.map((item) => {
          let obj = {
            name: item.fileId,
            url: item.fileUrl,
          };
          return obj;
        });

        let fileIds5 = datas.yingYeLicenceVo
          ? datas.yingYeLicenceVo.fileIds || []
          : [];
        this.fileNameLists_5 = fileIds5.map((item) => {
          let obj = {
            name: item.fileId,
            url: item.fileUrl,
          };
          return obj;
        });
        this.baseModel = JSON.parse(JSON.stringify(datas));
        delete this.baseModel.daoLuLicenceVo;
        delete this.baseModel.insuranccecVo;
        delete this.baseModel.jingYunLicenceVo;
        delete this.baseModel.yingYeLicenceVo;
        delete this.baseModel.fileIds;
        let labels = datas.portraitLabel || "";
        if (labels) {
          this.listShipper = labels.split(",").map((n) => {
            return {
              label: n,
            };
          });
        }
      });
    },
    // 删除
    delete(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm("确定要删除所选数据吗?", "提示:")
          .then((res) => {
            let delReq = {
              carIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              delReq.carIds.push(val.carId);
            });
            this.$API.delCar(delReq).then((res) => {
              if (res.data.status === "success") {
                try {
                  let num = 0;
                  let arr = this.tableConfig.tableData;
                  if (delReq.carIds.length > 2) {
                    delReq.carIds.map(function (v, i) {
                      num = arr.findIndex((element) => element.carId == v);
                      arr.splice(num, 1);
                    });
                  } else {
                    num = arr.findIndex(
                      (element) => element.carId == delReq.carIds[0]
                    );
                    arr.splice(num, 1);
                  }
                } catch {
                  this.GetData();
                }
                this.$message.success("已删除");
              }
            });
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    // 启用
    startUsing(data, t) {
      if (data) this.selectTableData = [data];
      let msg = "启用";
      if (t) msg = t;
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm(`确认${msg}所选数据?`, "提示:")
          .then((res) => {
            let params = {
              carIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              params.carIds.push(val.carId);
            });

            if (t) {
              // 禁用接口
              this.$API.stopCar(params).then((r) => {
                if (r.data.status === "success") {
                  this.GetData();
                  this.$message.success(r.data.message);
                }
              });
            } else {
              // 启用接口
              this.$API.startCar(params).then((e) => {
                if (e.data.status === "success") {
                  this.GetData();
                  this.$message.success(e.data.message);
                }
              });
            }
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    // 禁用
    Disable(data) {
      this.startUsing(data, "禁用");
    },

    // 查询事件
    queryBtn_ok() {
      this.GetData();
    },
    // 清空查询
    clearBtns() {
      this.$refs["queryForm"].$refs.forms.resetFields();
      this.GetData();
    },

    // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    // 跳转运单详情
    goYdDetails(a) {
      this.$message.success("你点我干嘛");
    },

    //  弹窗确认保存事件
    diaConfirmBtn() {
      this.$refs["diaform"].$refs.addForm.validate((valid) => {
        if (valid) {
          // 正常提交
          let param = {};
          for (let key in this.defaultBaseModel) {
            if (this.baseModel[key] || this.baseModel[key] == 0) {
              eval("param." + key + "='" + this.baseModel[key] + "'");
            } else {
              eval("param." + key + "=''");
            }
          }
          if (this.baseModel.carId) param.carId = this.baseModel.carId;

          // 车辆信息图片
          let files1 = this.fileNameLists_1.map((item) => {
            return item.name;
          });
          param.fileIds = files1 || [];
          param.portraitLabel =
            this.listShipper
              .map((n) => {
                return n.label;
              })
              .join() || "";
          // 车辆道路运输许可证
          let files3 = this.fileNameLists_3.map((item) => {
            return item.name;
          });
          this.daoLuLicenceReq.fileIds = files3 || [];
          // 车辆道路运输经营许可证
          let files4 = this.fileNameLists_4.map((item) => {
            return item.name;
          });
          this.jingYunLicenceReq.fileIds = files4 || [];

          // 车辆道路运输许可证
          param.daoLuLicenceReq = JSON.parse(
            JSON.stringify(this.daoLuLicenceReq)
          );
          // 车辆道路运输经营许可证
          param.jingYunLicenceReq = JSON.parse(
            JSON.stringify(this.jingYunLicenceReq)
          );
          let files5 = this.fileNameLists_5.map((item) => {
            return item.name;
          });
          this.yingYeLicenceReq.fileIds = files5 || [];
          param.yingYeLicenceReq = JSON.parse(
            JSON.stringify(this.yingYeLicenceReq)
          );
          // // 保险管理
          // let arrs3 = JSON.parse(JSON.stringify(this.insuranccecReq));
          // // 把删除的加上
          // arrs3 = [...arrs3, ...this.delArrs];
          // param.insuranccecReq = arrs3;

          console.log("param", param);

          if (param.carId) {
            // 修改接口
            this.$API.udpateCar(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog = false;
                this.GetData();
                this.ResetConfig();
              }
            });
          } else {
            // 新增接口
            this.$API.addCar(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog = false;
                this.GetData();
                this.ResetConfig();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.handleCloseDia();
    },
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.baseModel = {};
      this.selectTableData.length = 0;
      this.$refs.mytable.$refs.tables.clearSelection();
      this.isShowDialog = false;
      this.ResetConfig();
    },
    ResetConfig() {
      this.CarrierPage.pageStart = 1;
      this.DriverPage.pageStart = 1;
      this.DeptPage.pageStart = 1;
      this.diaFormConfig[1].formItem[0].options = [];
      this.diaFormConfig[1].formItem[1].options = [];
      this.diaFormConfig[11].formItem[0].options = [];
      this.GetObjectUserDownList("carrier");
      this.GetCardept();
      this.GetDrivers();
    },
  },
};
</script>
<style scoped lang="less">
/deep/ .el-collapse-item__header {
  font-size: 18px;
  font-weight: bold;
  border-bottom: 1px solid #d7d7d7;
  // color: #ef7c0a;
}

.goodsTable {
  /deep/ .el-input__icon {
    line-height: 30px;
  }
}

.iconList {
  text-align: center;

  .iconSize {
    font-size: 26px;
  }
}
.setper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 6px;
  border: 1px dashed #cccccc;
  .s_tem {
    margin: 6px;
    .el-icon-error {
      cursor: pointer;
      color: red;
    }
  }
}
</style>
  